import { IRadioButtonChipOptions } from '@components/common/formControl/radioButtonChip';
import { DropdownOptions } from '@components/common/formControl/dropdown';

export interface IGlueDetailsType {
	glueUsedAtSite: string;
	gradeUsed: string;
	brandAvailable: string;
	otherBrandName?: string;
	gluePotentialOfSite: string;
	competitionReason: string;
	glueUsedSoFar: string;
	conversionPotential: string;
	substratesCombinations: DropdownOptions[];
	productImages: File[];
	builder_name?: string;
	builder_phone_number?: string;
	builder_office_address?: string;
}

export const glueDetailsInitialValues: IGlueDetailsType = {
	glueUsedAtSite: '',
	gradeUsed: '',
	brandAvailable: '',
	otherBrandName: '',
	gluePotentialOfSite: '',
	competitionReason: '',
	glueUsedSoFar: '',
	conversionPotential: '',
	substratesCombinations: [],
	productImages: [],
	builder_name: '',
	builder_phone_number: '',
	builder_office_address: '',
};

export const GlueUsedLabel = {
	Fevicol: 'Fevicol',
	FB: 'F&B',
	Competition: 'Competition',
};

export const glueUsedList: IRadioButtonChipOptions[] = [
	{ id: 1, label: 'Fevicol', value: GlueUsedLabel.Fevicol },
	{ id: 2, label: 'F&B', value: GlueUsedLabel.FB },
	{ id: 3, label: 'Competition', value: GlueUsedLabel.Competition },
];

export const gradeUsedList: IRadioButtonChipOptions[] = [
	{ id: 1, label: 'Hi Per', value: 'Hi Per' },
	{ id: 2, label: 'Marine', value: 'Marine' },
	{ id: 3, label: 'SH', value: 'SH' },
];

export const substratesOptions: DropdownOptions[] = [
	{ id: 1, value: 'PVC Sheet' },
	{ id: 2, value: 'WPC Board' },
	{ id: 3, value: 'Veneer' },
	{ id: 4, value: 'Acrylic Sheet' },
	{ id: 5, value: 'MDF Board' },
	{ id: 6, value: 'ACP Sheet' },
	{ id: 7, value: 'Laminate' },
	{ id: 8, value: 'Plywood' },
];
